/**
 * Time-stats utilities. Normalize API response by metric name so the UI
 * never relies on property order or position for Wait / Service / Turnaround.
 */
import type { TimeStats, TimeStatMetric } from '@crowdctrl/core';

/** Empty metric so UI shows "—" (avg is undefined). */
const EMPTY_METRIC = {} as TimeStatMetric;

/**
 * Normalize raw stats from the API into TimeStats by reading each metric by name.
 * Guarantees Wait Time, Service Time, and Turnaround Time are always keyed correctly.
 */
export function normalizeTimeStats(raw: TimeStats | null | undefined): TimeStats | null {
  if (raw == null) return null;
  return {
    waitTime: raw.waitTime ?? EMPTY_METRIC,
    serviceTime: raw.serviceTime ?? EMPTY_METRIC,
    turnaroundTime: raw.turnaroundTime ?? EMPTY_METRIC,
  };
}
